import * as ToastPrimitive from '@radix-ui/react-toast';
import { cn } from '@/utils';
import React, { useState } from 'react';
import { useMediaQuery } from '@/Hooks/useMediaQuery';
import useTypedPage from '@/Hooks/useTypedPage';
import Billing from "@/Components/Billing";

export default function Toast({ toast }: { toast: App.Data.ToastData }) {
  const { props } = useTypedPage();
  const [open, setOpen] = useState(true);
  const isMd = useMediaQuery('(min-width: 768px)');
  const style = props.jetstream.flash?.bannerStyle || 'success';
  const message = props.jetstream.flash?.banner || '';

  return (
    <ToastPrimitive.Provider swipeDirection={isMd ? 'right' : 'down'}>
      <ToastPrimitive.Root
        open={open}
        onOpenChange={setOpen}
        className={cn(
          'fixed inset-x-4 bottom-4 z-50 w-auto rounded-lg shadow-lg md:bottom-auto md:left-auto md:right-4 md:top-4 md:w-full md:max-w-sm',
          'bg-white dark:bg-brand-dark-50',
          'radix-state-open:animate-toast-slide-in-bottom md:radix-state-open:animate-toast-slide-in-right',
          'radix-state-closed:animate-toast-hide',
          'radix-swipe-direction-right:radix-swipe-end:animate-toast-swipe-out-x',
          'radix-swipe-direction-right:translate-x-radix-toast-swipe-move-x',
          'radix-swipe-direction-down:radix-swipe-end:animate-toast-swipe-out-y',
          'radix-swipe-direction-down:translate-y-radix-toast-swipe-move-y',
          'radix-swipe-cancel:translate-x-0 radix-swipe-cancel:duration-200 radix-swipe-cancel:ease-[ease]',
          'focus:outline-none focus-visible:ring-1 focus-visible:ring-brand focus-visible:ring-opacity-75',
          {
            'ring-1 ring-inset ring-brand-dark': style == 'success',
            'ring-1 ring-inset ring-red-700': style == 'danger',
          },
        )}
      >
        <div className="flex">
          <div className="flex w-0 flex-1 items-center py-4 pl-5">
            <div className="radix w-full">
              {message ? (
                <ToastPrimitive.Title className="text-sm font-medium text-brand-dark-75 dark:text-brand-25">
                  {message} {style}
                </ToastPrimitive.Title>
              ) : (
                <>
                  <ToastPrimitive.Title className="text-sm font-medium text-brand-dark-75 dark:text-brand-25">
                    {toast.title}
                  </ToastPrimitive.Title>
                  {toast.message && (
                    <ToastPrimitive.Description className="mt-1 text-sm text-brand-dark-25 dark:text-brand-100">
                        {toast.message.includes('Go Pro') && (
                            <Billing>
                                {toast.message}
                            </Billing>
                        ) || (
                            toast.message
                        )}
                    </ToastPrimitive.Description>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="flex">
            <div className="flex flex-col space-y-1 px-3 py-2">
              <div className="flex h-0 flex-1">
                {toast.action && (
                  <ToastPrimitive.Action
                    altText="view now"
                    className="darktext-brand flex w-full items-center justify-center rounded-lg border border-transparent px-3 py-2 text-sm font-medium text-brand hover:bg-gray-50 focus:z-10 focus:outline-none focus-visible:ring-1 focus-visible:ring-brand focus-visible:ring-opacity-75 dark:text-brand-dark dark:hover:bg-brand-dark-75"
                    onClick={e => {
                      e.preventDefault();
                      window.open(toast.action?.url);
                    }}
                  >
                    {toast.action.label}
                  </ToastPrimitive.Action>
                )}
              </div>
              <div className="flex h-0 flex-1">
                <ToastPrimitive.Close className="flex w-full items-center justify-center rounded-lg border border-transparent px-3 py-2 text-sm font-medium text-brand-dark-25 hover:bg-gray-50 focus:z-10 focus:outline-none focus-visible:ring-1 focus-visible:ring-brand focus-visible:ring-opacity-75 dark:text-brand-25 dark:hover:bg-brand-dark-75">
                  Dismiss
                </ToastPrimitive.Close>
              </div>
            </div>
          </div>
        </div>
      </ToastPrimitive.Root>

      <ToastPrimitive.Viewport />
    </ToastPrimitive.Provider>
  );
}
